export default __webpack_public_path__ + "static/media/shield-blue-xl.0646bb61.svg";